import React, {useEffect, useState} from "react";
import {Box, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, useTheme} from "@mui/material";
import {useSearchParams} from "react-router-dom";

export const DropDownFilterDesktop = ({ filter }) => {
    const theme = useTheme();
    const [ searchParams, setSearchParams ] = useSearchParams();

    const getSearchParams = () => {
        const param = searchParams.get(filter.key);
        return param ? param.split(",") : [];
    }

    const [selected, setSelected] = useState(getSearchParams);
    const [showAll, setShowAll] = useState(false);

    useEffect(() => {
        setSelected(getSearchParams());
    }, [searchParams]);

    const handleToggle = (value) => {
        const currentIndex = selected.indexOf(value);
        const newSelected = [...selected];

        if (currentIndex === -1) {
            newSelected.push(value);
        } else {
            newSelected.splice(currentIndex, 1);
        }

        if (newSelected.length) {
            searchParams.set(filter.key, newSelected.join(","));
        } else {
            searchParams.delete(filter.key);
        }

        setSearchParams(searchParams);
    };

    return (
        <Box sx={{margin: "5px 0 20px 0"}}>
            <FormControl component="fieldset" fullWidth>
                <FormLabel component="legend">{filter.label}</FormLabel>
                <FormGroup>
                    {(showAll ? filter.options : filter.options.slice(0, 4)).map((option, index) => (
                        <FormControlLabel
                            sx={index > 0 ? {paddingTop: "10px"} : {paddingTop: "5px"}}
                            key={option.value}
                            control={
                                <Checkbox
                                    sx={{paddingX: "7px", paddingY: 0}}
                                    checked={selected.includes(option.value)}
                                    onChange={() => handleToggle(option.value)}
                                    name={option.label}
                                />
                            }
                            label={option.label}
                        />
                    ))}
                </FormGroup>
                {filter.options.length > 4 && (
                    <Box sx={{mt: 1}}>
                        <button
                            type="button"
                            onClick={() => setShowAll((prev) => !prev)}
                            style={{
                                background: "none",
                                border: "none",
                                color: theme.palette.jagtred.main,
                                cursor: "pointer",
                                padding: 0,
                                font: "inherit",
                                textDecoration: "underline"
                            }}
                        >
                            {showAll ? "Vis færre" : "Vis alle"}
                        </button>
                    </Box>
                )}
            </FormControl>
        </Box>
    );
};

